export enum JobApplicationStatuses {
  NEW = 1,
  ARCHIVED = 2,
}
